import { Component, ChangeEvent, MouseEvent } from 'react';
import moment from 'moment';
import { withTranslation, WithTranslation } from 'react-i18next';
import { defaultDeviceScript } from 'reducers/buildingsReducer';
import { UtcTime } from 'shared/models';

require('./deviceScriptSection.css');

declare const $: any;

export type Props = {
    script: string | null;
    readOnly: boolean;
    groupName: string;
    hasChanges: boolean;
    lastCheckIn: UtcTime | null;
    onChangeScript: (script: string) => void;
    onClickPublishToDevice: () => void;
    onClickPublishToGroup: () => void;
    onClickPublishToBuilding: () => void;
    onClickReset: () => void;
};

// eslint-disable-next-line @typescript-eslint/naming-convention -- TODO: rewrite as a functional component
export const DeviceScriptSection = withTranslation()(class _DeviceScriptSection extends Component<Props & WithTranslation> {
    dropDown?: HTMLDivElement | null;

    handleClickDropDown = () => {
        $(this.dropDown).dropdown('show');
    };

    setRef = (ref: HTMLDivElement | null) => {
        this.dropDown = ref;
    };

    handleClickPublishToDevice = (e: MouseEvent<HTMLElement>) => {
        $(this.dropDown).dropdown('hide');
        this.props.onClickPublishToDevice();
        e.preventDefault();
        e.stopPropagation();
    };

    handleClickPublishToGroup = (e: MouseEvent<HTMLDivElement>) => {
        $(this.dropDown).dropdown('hide');
        this.props.onClickPublishToGroup();
        e.preventDefault();
        e.stopPropagation();
    };

    handleClickPublishToBuilding = (e: MouseEvent<HTMLDivElement>) => {
        $(this.dropDown).dropdown('hide');
        this.props.onClickPublishToBuilding();
        e.preventDefault();
        e.stopPropagation();
    };

    handleChangeScript = (e: ChangeEvent<HTMLTextAreaElement>) => {
        this.props.onChangeScript(e.target.value);
    };

    render() {
        const { script, readOnly, hasChanges, lastCheckIn, onClickReset, groupName, t, i18n } = this.props;
        return (
            <section id="device-script-section">
                <header>
                    <h2>{ t('DEVICE.COMMANDS.SCRIPT') }</h2>
                    <div className="last-check-in">
                        <span style={ { opacity: .8, marginRight: '.25em' } }>{ t('DEVICE.COMMANDS.LAST_CHECK_IN') }</span>
                        { lastCheckIn && <span>{ moment(lastCheckIn).locale(i18n.language).fromNow() }</span> }
                        { !lastCheckIn && <span style={ { opacity: .5 } }>{ t('DEVICES.NEVER_CHECKED_IN') }</span> }
                    </div>
                </header>
                <textarea
                    id="device-script-section_script"
                    readOnly={ readOnly }
                    onChange={ this.handleChangeScript }
                    value={ script === null ? defaultDeviceScript : script }
                />
                <div>
                    <div className="ui buttons">
                        <button
                            type="button"
                            className={ `ui ${hasChanges ? 'primary' : ''} button` }
                            onClick={ this.handleClickPublishToDevice }
                        >
                            { t('COMMAND.PUBLISH') }
                        </button>
                        <div className="ui floating dropdown button" onClick={ this.handleClickDropDown } ref={ this.setRef }>
                            <i className="dropdown icon"></i>
                            <div className="menu" id="publish-script-menu">
                                <div className="item" onClick={ this.handleClickPublishToDevice }>
                                    { t('COMMAND.PUBLISH_TO_DEVICE')}
                                </div>
                                <div className="item" onClick={ this.handleClickPublishToGroup }>
                                    { t('COMMAND.PUBLISH_TO_GROUP', [ groupName ])}
                                </div>
                                <div className="item" onClick={ this.handleClickPublishToBuilding }>
                                    { t('COMMAND.PUBLISH_TO_BUILDING') }
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    <span style={ { opacity: .5, fontSize: '.9em', marginLeft: '1em' } }>
                        { t(hasChanges ? 'DEVICE.COMMANDS.PUBLISH_TIP' : 'DEVICE.COMMANDS.NO_CHANGES_TIP') }
                    </span>
                    
                    <button
                        type="button"
                        className="ui button"
                        onClick={ onClickReset }
                        style={ { float: 'right' } }
                    >
                        { t('COMMAND.RESET') }
                    </button>
                </div>
            </section>
        );
    }
});
